import React from "react";

import { useQuery } from "@apollo/client";
import Hidden from "@material-ui/core/Hidden";
import PropTypes from "prop-types";

import RbFlexTable from "components/RbFlexTable";
import RbFlexTableBody from "components/RbFlexTableBody";
import RbFlexTableCell from "components/RbFlexTableCell";
import RbFlexTableHead from "components/RbFlexTableHead";
import RbFlexTableRow from "components/RbFlexTableRow";
import { carListQuery } from "graphql/car";
import useMatchBreakpoints from "hooks/useMatchBreakpoints";
import { filterByText } from "utils/filterUtils";
import { sortByField } from "utils/sortUtils";

import CarNewRow from "./CarNewRow/CarNewRow";
import CarRow from "./CarRow";

function CarsContent(props) {
  const { filter, sort, newOpen, onCancelNew } = props;

  const actionsFlex = useMatchBreakpoints({ xs: "0 48px", md: "0 88px" });

  const { data: { carList = [] } = {} } = useQuery(carListQuery);

  const filtered = filterByText(carList, filter, ["model", "year"]);

  const sorted = sortByField(filtered, sort.by, sort.order);

  return (
    <RbFlexTable variant="card">
      <RbFlexTableHead>
        <RbFlexTableRow>
          <Hidden smDown>
            <RbFlexTableCell flex="0 60px">ID</RbFlexTableCell>
          </Hidden>
          <RbFlexTableCell>Model</RbFlexTableCell>
          <Hidden smDown>
            <RbFlexTableCell>Color</RbFlexTableCell>
          </Hidden>
          <Hidden smDown>
            <RbFlexTableCell flex="0 100px" align="right">
              Year
            </RbFlexTableCell>
          </Hidden>
          <RbFlexTableCell flex="0 100px" align="right">
            Price
          </RbFlexTableCell>
          <RbFlexTableCell flex={actionsFlex} />
        </RbFlexTableRow>
      </RbFlexTableHead>
      <RbFlexTableBody>
        <CarNewRow expanded={newOpen} onCancel={onCancelNew} />
        {sorted.map((car) => (
          <CarRow key={car.id} car={car} />
        ))}
      </RbFlexTableBody>
    </RbFlexTable>
  );
}

CarsContent.propTypes = {
  filter: PropTypes.string.isRequired,
  newOpen: PropTypes.bool.isRequired,
  onCancelNew: PropTypes.func.isRequired,
  sort: PropTypes.object.isRequired,
};

export default React.memo(CarsContent);
